import React from "react";
import PropTypes from "prop-types";

const styleIcon = (iconUrl) => ({
  backgroundImage: `url(${iconUrl})`,
  display: "block"
});

const Icon = ({ iconUrl, onClick, style, title }) => (
  <i style={{...style, ...styleIcon(iconUrl)}} className="generic-icon" onClick={onClick} title={title}/>
);

Icon.propTypes = {
  iconUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string
};

export default Icon;
